import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconHouseWhite from '../build/icon-house-white'

export const IconHouseWhiteComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconHouseWhite} />
}

export default IconHouseWhiteComponent
